module.exports = __webpack_public_path__ + "static/media/animated.291ffc23.svg";